function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import { useCurrentProject } from 'common/contexts/react/current-project-context';
import { BannerReact } from 'common/components/banner';
import { BannerAction, BannerTheme, CallToAction } from 'common/components/banner/types';
import { AccountPlanType } from 'common/report/queries/app-api/project-metadata-client';
import { NO_ICON } from 'common/components/banner/helpers';
import { ReplayBannerType } from './util';
const UTM_SOURCE_SR_GATE = "utm_source=session-replay-gate"; // this is also duplicated in webapp code: webapp/app_api/projects/banners/views.py:get_session_replay_ingestion_blocked_banner
export interface ReplayBannerProps {
  bannerType: ReplayBannerType;
}
type BannerMessagingType = Partial<{ [replayBannerKey in ReplayBannerType]: {
  headerText: string;
  bodyText: Partial<{ [accountPlanKey in AccountPlanType]: string }>;
} }>;
const BannerMessaging: BannerMessagingType = {
  [ReplayBannerType.Dismissible]: {
    headerText: "You've used 85% of your session replay volume for this month.",
    bodyText: {
      [AccountPlanType.Free]: "Your access to session replays will be limited when your volume is reached. Increase your volume by upgrading to the Growth plan.",
      [AccountPlanType.Growth]: "Your access to session replays will be limited when your volume is reached. Increase your volume by upgrading to the Enterprise plan.",
      [AccountPlanType.Enterprise]: "Your access to session replays will be limited when your volume is reached. To increase your session replay volume, talk to sales."
    }
  },
  [ReplayBannerType.NonDismissible]: {
    headerText: "More insights are waiting for you",
    bodyText: {
      [AccountPlanType.Free]: "Unlock up to 20,000 session replays every month when you upgrade to the Growth plan.",
      [AccountPlanType.Growth]: "Purchase custom amounts of session replays by upgrading to the Enterprise plan.",
      [AccountPlanType.Enterprise]: "To increase your session replay volume, talk to sales."
    }
  }
};
function getUpgradeCtaByAccountType(accountType: AccountPlanType, orgId: number | undefined, bannerType: ReplayBannerType): CallToAction {
  let cta: CallToAction = {
    actionName: BannerAction.Upgrade,
    trackEventName: "Session Replay Upsell Banner Clicked",
    trackProps: {
      account_type: accountType,
      banner_type: bannerType
    },
    icon: "brand-upgrade",
    text: "Upgrade Plan",
    href: "/pricing/plan-builder/?org=".concat(orgId, "&").concat(UTM_SOURCE_SR_GATE)
  };
  if (accountType === AccountPlanType.Enterprise || accountType === AccountPlanType.Growth) {
    cta = _objectSpread(_objectSpread({}, cta), {}, {
      text: "Talk to Sales",
      href: "/contact-us/sales/?".concat(UTM_SOURCE_SR_GATE)
    });
  }
  return cta;
}
export function ReplayBanner(props: ReplayBannerProps) {
  var _currentProject$get$v, _currentProject$get$v2, _BannerMessaging$prop, _BannerMessaging$prop2;
  const currentProject = useCurrentProject();
  const orgId = (_currentProject$get$v = currentProject.get().value) === null || _currentProject$get$v === void 0 ? void 0 : _currentProject$get$v.organizationId;
  const accountType = ((_currentProject$get$v2 = currentProject.get().value) === null || _currentProject$get$v2 === void 0 ? void 0 : _currentProject$get$v2.getAccountPlanType()) || AccountPlanType.Unknown;
  const [isBannerVisible, setIsBannerVisible] = useState<boolean>(true);
  if (!isBannerVisible || props.bannerType === ReplayBannerType.NoBanner) {
    return null;
  }
  const _ctas: CallToAction[] = [getUpgradeCtaByAccountType(accountType, orgId, props.bannerType)];
  if (props.bannerType === ReplayBannerType.Dismissible) {
    _ctas.push({
      actionName: BannerAction.Dismiss,
      trackEventName: "Session Replay Upsell Banner Dismissed",
      trackProps: {
        account_type: accountType,
        banner_type: props.bannerType
      },
      text: "Dismiss"
    });
  }
  return <BannerReact theme={BannerTheme.Info} headerText={(_BannerMessaging$prop = BannerMessaging[props.bannerType]) === null || _BannerMessaging$prop === void 0 ? void 0 : _BannerMessaging$prop.headerText} bodyText={(_BannerMessaging$prop2 = BannerMessaging[props.bannerType]) === null || _BannerMessaging$prop2 === void 0 ? void 0 : _BannerMessaging$prop2.bodyText[accountType]} ctas={_ctas} icon={NO_ICON} onAction={ev => {
    if (ev.detail.actionName === BannerAction.Dismiss) {
      setIsBannerVisible(false);
    }
  }} data-sentry-element="BannerReact" data-sentry-component="ReplayBanner" data-sentry-source-file="index.tsx" />;
}